import React from 'react';
import { useTheme } from '../ThemeContext';
import { Button } from '../../core/Button';
import { Sun, Moon, Loader2 } from 'lucide-react';

export const ThemeToggleButton: React.FC = () => {
  const { theme, toggleTheme, isLoading } = useTheme();

  if (isLoading) {
    return (
      <Button variant="icon" title="Loading theme...">
        <Loader2 style={{ animation: 'spin 1s linear infinite' }} />
      </Button>
    );
  }

  return (
    <Button
      onClick={toggleTheme}
      variant="icon"
      title={`Switch to ${theme === 'light' ? 'dark' : 'light'} theme`}
    >
      {theme === 'light' ? <Sun /> : <Moon />}
    </Button>
  );
};

export const ThemeIcon: React.FC = () => {
  const { theme, isLoading } = useTheme();

  if (isLoading) {
    return (
      <Loader2 size={16} style={{ animation: 'spin 1s linear infinite' }} />
    );
  }

  return theme === 'light' ? <Sun size={16} /> : <Moon size={16} />;
};
